import { ComponentSettings } from "../settings/settings";

const settings = {
  permission: {},
  text: {},
  list: {},
  url: {},
  field: {},
  additionalInfo: {},
};

export const totalCostLTB: ComponentSettings<typeof settings> = settings;
